"use client";

import { ArrowTopRightOnSquare } from "@/components/atom/mark/arrowTopRightOnSquare";
import { TimeSchedule } from "@/components/moleculer/events/2024techfes/timeSchedule";
import Link from "next/link";
import type { ReactNode } from "react";

const Card = (props: { title: string; children: ReactNode }) => {
	return (
		<div className={"flex flex-col justify-start px-4 md:px-16 py-4 gap-4"}>
			<p className={"text-2xl md:text-4xl font-bold "}>{props.title}</p>
			<div className={"text-lg md:text-2xl"}>{props.children}</div>
		</div>
	);
};
const CompanyCard = (props: {
	name: string;
	imgPath: string;
	alt: string;
	hasPadding?: boolean;
	url: string;
}) => {
	return (
		<div className={"flex-col flex gap-4"}>
			<img
				src={props.imgPath}
				className={`w-80 h-auto bg-white ${props.hasPadding && "p-8"}`}
				alt={props.alt}
			/>
			<button
				type="button"
				className={"flex hover:cursor-pointer hover:underline"}
				onClick={(): void => {
					window.open(props.url);
				}}
			>
				<p>{props.name}</p>
				<ArrowTopRightOnSquare />
			</button>
		</div>
	);
};
const ApplyButton = () => (
	<button
		type="button"
		className={"bg-black text-white px-20 py-4 w-fit mx-auto text-2xl rounded"}
		onClick={(): void => {
			window.open(
				"https://docs.google.com/forms/d/e/1FAIpQLSe3J78vwHFATry8Fq7U5TqhUOf0_Vt25kujrXCqibhgJOTwSQ/viewform",
			);
		}}
	>
		応募する
	</button>
);

export const AboutHackathon = () => {
	const schedules = [
		{
			title: "本イベントについて",
			dateFrom: "13:00",
			dateTo: "13:05",
			height: "h-20",
		},
		{
			title: "ハッカソン説明",
			dateFrom: "13:05",
			dateTo: "13:20",
			height: "h-20",
		},
		{
			title: "発表&交流　①",
			dateFrom: "13:20",
			dateTo: "14:20",
			height: "h-32",
		},
		{
			title: "発表&交流　②",
			dateFrom: "14:30",
			dateTo: "15:30",
			height: "h-32",
		},
		{
			title: "発表&交流　③",
			dateFrom: "15:40",
			dateTo: "16:40",
			height: "h-32",
		},
		{
			title: "審査",
			dateFrom: "16:40",
			dateTo: "17:00",
			height: "h-20",
		},
		{ title: "結果発表", dateFrom: "17:00", dateTo: "17:30", height: "h-20" },
		{ title: "写真撮影", dateFrom: "17:30", dateTo: "18:00", height: "h-20" },
	];

	return (
		<div className={"flex flex-col"}>
			<div
				className={
					'bg-[url("/events/2024techfes/cover.png")] text-black py-16 flex flex-col gap-4 '
				}
			>
				<div
					className={
						"bg-white w-full mx-auto p-4 md:p-12 text-lg text-center gap-4 flex flex-col rounded"
					}
				>
					<h2 className={"text-xl md:text-5xl font-bold text-center"}>
						DAO型高専ハッカソン
					</h2>
					<p className={"text-xs md:text-lg"}>
						最先端のWeb3技術とクラウドの知識を学べる特別セミナーを開催します！
						<br />
						未来のエンジニアに必要なスキルを身につけ、次世代のITを一緒に探求しませんか？
					</p>
				</div>
				<ApplyButton />
				<div
					className={
						'flex flex-col gap-4 mb-12 w-11/12 md:w-10/12 mx-auto md:py-16 rounded bg-[url("/events/2024techfes/cover_white.svg")]'
					}
				>
					<Card title={"テーマ"}>
						<p>「xxxを活用したxxx！」</p>
					</Card>
					<Card title={"発表会"}>
						<p>2025年2月24日（月） 13:00〜18:00</p>
					</Card>
					<Card title={"定例DAO会議"}>
						<>
							<p>初回：2024年12月23日（月）20:00〜 以降は、毎週火曜18:00〜</p>
							<ul className="list-disc ml-6">
								<li>テスト期間は調整中</li>
								<li>欠席可／途中参加可</li>
							</ul>
						</>
					</Card>
					<Card title={"申込締切"}>
						<p>2025年1月1日（火）</p>
					</Card>
					<Card title={"プロジェクト予算"}>
						<>
							<p>10万円</p>
							<p>※予算の使い方は、皆さんで決定します！</p>
						</>
					</Card>
					<Card title={"賞品"}>
						<p>皆さんで決定します！</p>
					</Card>
					<Card title={"会場"}>
						<p>オンライン（特設メタバース内）</p>
					</Card>
					<Card title={"応募条件"}>
						<ul className="list-disc ml-6">
							<li>高専人であること</li>
							<li>自前でパソコンを有していること（Mac、Windowsは問わない）</li>
							<li>全ての時間帯で参加可能であること</li>
						</ul>
					</Card>
					<Card title={"応募フォーム"}>
						<Link
							href={
								"https://docs.google.com/forms/d/13Eb4_VUf8nhuwLMSa1KwULsqQ0RCtG14getDCoThgY4/edit"
							}
							className={"underline text-sky-600"}
						>
							応募はこちら
						</Link>
					</Card>
					<Card title={"タイムスケジュール"}>
						<TimeSchedule schedules={schedules} date={"2025年2月24日（月）"} />
					</Card>
					<Card title={"主催"}>
						<CompanyCard
							name={"株式会社プロッセル"}
							imgPath={"/events/2024techfes/prossell.png"}
							alt={"プロッセルロゴ"}
							url={"https://prossell.jp/"}
							hasPadding
						/>
					</Card>
					<Card title={"協力"}>
						<CompanyCard
							name={"国立大学法人 長岡技術科学大学"}
							imgPath={"/events/2024techfes/nut.svg"}
							alt={"長岡技科大ロゴ"}
							url={"https://www.nagaokaut.ac.jp/"}
							hasPadding
						/>
					</Card>
				</div>
				<ApplyButton />
			</div>
		</div>
	);
};
